import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/eTrack/existingQuote/initialState.existingQuote.data';

const ETrackExistingQuote = createSlice({
  name: 'eTrackExistingQuote',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.searchParams[action?.payload?.key] = action?.payload?.value;
    },
    setSearchResult: (state, action) => {
      state.searchResult = action?.payload || initialState.searchResult;
      state.totalRecords = state.searchResult?.totalRecords;
      if(state.searchResult?.totalRecords > 0) {
        state.searchResult = state.searchResult?.quotes?.sort((a, b) => new Date(b.createDate) - new Date(a.createDate))
      }
    },
    setQuoteDetails: (state, action) => {
      state.quoteDetail = action?.payload || initialState.quoteDetail;
    },
    setQuoteItems: (state, action) => {
      state.quoteItems = action?.payload || initialState.quoteItems;
    },
    resetValues: (state, action) => {
      state.searchParams = initialState.searchParams;
      state.searchResult = initialState.searchResult;
      state.quoteItems = initialState.quoteItems;
      state.quoteDetail = initialState.quoteDetail;
      state.searchText = initialState.searchText;
      if((action?.payload === '' || action?.payload === undefined) && state.radioButtonValue !== '') {
        state.radioButtonValue = initialState.radioButtonValue;
      }
      else {
        state.radioButtonValue = action?.payload;
      }
    },
    setRadioButtonValue: (state, action) => {
      state.radioButtonValue = action?.payload;
    },
    setSearchFastFindQuoteText: (state, action) => {
      state.searchText = action?.payload;
    },
  },
});

export const {
  setSearchParams,
  setSearchResult,
  setQuoteDetails,
  setQuoteItems,
  resetValues,
  setRadioButtonValue,
  setSearchFastFindQuoteText,
} = ETrackExistingQuote.actions;
export default ETrackExistingQuote.reducer;
